import { Injectable } from '@angular/core';
import { ButtonItem } from '../../../../shared/button/button.model';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../shared/shared-service-registry';
import { SimpleEntityButtonService } from '../../../../shared/services/searchable-entity/simple-entity/simple-entity-button.service';
import { ViewMyPrintJobsActionService } from './view-my-print-jobs-action.service';

@Injectable()
export class ViewMyPrintJobsButtonService extends SimpleEntityButtonService {

  protected actionService: ViewMyPrintJobsActionService;

  constructor(coreServiceRegistry: CoreServiceRegistry,
      sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  protected getAllButtons(): any {
    return {
      'search-table': [
        new ButtonItem('Search', this.resourceService
          .get('lbl_criteria_srch'), '', 'icon-search-action.svg', []),
        new ButtonItem('Print', this.resourceService
          .get('btn_print'), 'print_job_print', 'icon-print.svg', []),
        new ButtonItem('Print Preview', this.resourceService
          .get('lbl_preview'), 'my_print_job_preview', 'icon-print-preview.svg', [])
      ]
    };
  }

  public getButtonsForPanel(panelId: string) {
    return this.userButtonMap[panelId];
  }

  public handleButtonPanelActions(action: string) {
    switch (action) {
      case 'Search': {
        this.actionService.showSearchFilterPopup = true;
        break;
      }
      case 'Print': {
        this.actionService.printSelectedJobs();
        break;
      }
      case 'Print Preview': {
        this.actionService.printPreviewJobs();
        break;
      }
      default: break;
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/reports/view-my-print-jobs/services/view-my-print-jobs-button.service.ts